import { ComponentFactoryResolver, Inject, Injectable, Injector, LOCALE_ID, Optional } from "@angular/core";
import { StartProcessPayload } from "@edp-bpm/universal-runtime-api";
import { FrameContext } from "@farris/devkit";
import { BpmRuntimeDevkitService } from "../bpm-runtime-devkit/bpm-runtime-devkit.service";
import { MessagerService } from "@farris/ui-messager";
import { NotifyService } from "@farris/ui-notify";
import { LocalePipe } from "../bpm-runtime-devkit/pipe/locale.pipe";
import { BPM_RUNTIME_DEVKIT_LANG_RESOURCES } from "../bpm-runtime-devkit/i18n/lang.resource";

@Injectable()
export class BpmRuntimeDevkitWebCmpService {
    constructor(
        public bpmRuntimeDevkitService: BpmRuntimeDevkitService,
        @Optional() public frameContext: FrameContext,
        public inj: Injector,
        public cfr: ComponentFactoryResolver,
        @Inject(LOCALE_ID) public localeId: string,
        @Optional() public messager: MessagerService,
        @Optional() public notify: NotifyService,
        @Optional() public localePipe: LocalePipe,
    ) {
        this.messager = messager || this.inj.get(MessagerService, null);
        this.notify = notify || this.inj.get(NotifyService, null);
        this.localePipe = localePipe || this.inj.get(LocalePipe, null) || new LocalePipe(localeId || 'zh-CHS', BPM_RUNTIME_DEVKIT_LANG_RESOURCES);
    }

    /**
     * 启动业务流程
     * @param payload 启动业务流程参数
     * @returns 
     */
    startProcess(payload: StartProcessPayload): any {
        this.bpmRuntimeDevkitService.startProcess(payload).subscribe(
            (res) => {
                if (res.procDefs && res.procDefs.length > 1) {
                    this.messager.error(this.localePipe.instant("moreThanOneProcessCanBeStarted"));
                    return;
                }
                if (res.procInstId) {
                    this.notify.success(this.localePipe.instant('startProcessSuccess'))
                } else {
                    this.messager.error(this.localePipe.instant("failedToStartProcess"));
                }
            },
            (err) => {
                this.messager.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
                throw err;
            }
        );
    }

    /**
     * 通过运行框架查看流程实例
     * @param procInstId 业务流实例ID
     */
    viewProcessInstance(procInstId: string) {
        this.bpmRuntimeDevkitService.viewProcessInstance(procInstId);
    }
}